import ui from "./ui.module.css";

interface Props {
  seconds: number;
  onChange: (seconds: number) => void;
  min?: number;
  max?: number;
}

export function Stepper({ seconds, onChange, min = 3, max = 15 }: Props) {
  return (
    <div className={ui.stepper}>
      <button
        type="button"
        className={ui.stepButton}
        aria-label="Shorter"
        disabled={seconds <= min}
        onClick={() => onChange(seconds - 1)}
      >
        −
      </button>
      <div className={ui.stepValue}>{seconds} s</div>
      <button
        type="button"
        className={ui.stepButton}
        aria-label="Longer"
        disabled={seconds >= max}
        onClick={() => onChange(seconds + 1)}
      >
        +
      </button>
    </div>
  );
}
